<template>
  <div class="main">
    <div class="body">
      <div class="border">
        <div class="title">专业与学科</div>
        <div class="txt">
          <div style="TEXT-INDENT: 2em">
            <p><strong>1</strong><strong>、</strong><strong>与语文、外语对应的专业</strong></p>
            <p>
              汉语语言文学、对外汉语、新闻学、传播学、广告学、广播电视编导、戏剧影视文学、英语语言文学、葡萄牙语、阿拉伯语、西班牙语、朝鲜语、日语、意大利语、法语、德语</p>
            <p><strong>2</strong><strong>、</strong><strong>与数学对应，或以数学为工具的专业</strong> </p>
            <p>
              数学与应用数学、软件工程、保险精算、金融工程、经济学-数学双学位实验班、图书馆学、统计学</p>
            <p><strong>3</strong><strong>、</strong><strong>以数学或英语为工具的专业</strong> </p>
            <p>
              经济学、金融学、国际经济与贸易、税务、农村区域发展、工商管理、会计学、人力资源管理、旅游管理、土地资源管理、农林经济管理</p>
            <p><strong>4</strong><strong>、</strong><strong>与物理对应，以数学为工具的专业</strong> </p>
            <p>
              天文学、应用气象学、教育技术、机械设计制造及其自动化、机械制造及自动化、材料成型与控制工程、过程装备与控制工程、车辆工程、工业设计、汽车运用工程、船舶与海洋工程热能与动力工程、农业机械化及其自动化、农业建筑环境与能源工程、电子信息科学与技术、电气工程及其自动化、测控技术与仪器、自动化、通信工程、电子信息工程、信息工程（光电信息工程）、计算机科学与技术、理科实验班（信息技术）、土木工程（民用建筑）、建筑环境与设备工程、给水与排水工程、港口航道与海岸工程、水利水电工程、工程力学、安全工程、包装工程、航天类、飞行器设计与工程（航空类）、飞行器动力工程、飞行器环境与生命保障、探测制导与控制技术、适航技术与管理、农业水利工程、水文与水资源工程 工程管理、农业工程、勘察技术与工程</p>
            <p><strong>5</strong><strong>、</strong><strong>与化学对应的专业</strong> </p>
            <p>
              化学、应用化学、环境科学与工程、材料科学与工程、高分子材料、环境工程、化学工程与工艺、制药工程、木材科学与工程、林产化工、药学</p>
            <p><strong>6</strong><strong>、</strong><strong>与生物、化学对应的专业</strong> </p>
            <p>
              生物技术、生物工程、食品科学与工程、葡萄与葡萄酒工程、食品质量与安全、农学 、
              园艺、植物保护、草业科学、生态学、农业资源与环境、动物科学、动物医学、水产养殖、
              基础医学、临床医学、护理学、口腔医学、中医学、针灸推拿</p>
            <p><strong>7</strong><strong>、</strong><strong>与哲学、法律、思想道德修养对应的专业</strong> </p>
            <p>
              哲学、法学、社会学与社会工作、政治学与行政学、国际政治、外交学、思想政治教育</p>
            <p><strong>8</strong><strong>、</strong><strong>数学经济交叉专业</strong> </p>
            <p>
              电子商务、物流工程、信息管理与信息系统 </p>
          </div>
          <div style="TEXT-INDENT: 2em">
            <p><strong>9</strong><strong>、</strong><strong>与地理对应的专业</strong> </p>
            <p>
              地理科学、地理信息系统 </p>
            <p><strong>10</strong><strong>、</strong><strong>与历史对应的专业</strong> </p>
            <p>
              历史学 </p>
            <p><strong>11</strong><strong>、</strong><strong>生物、数学交叉专业</strong> </p>
            <p>
              心理学、教育学、教育经济与管理、特殊教育、学前教育 </p>
            <p><strong>12</strong><strong>、</strong><strong>以绘画为工具，多学科交叉专业</strong> </p>
            <p>
              城市规划、建筑学、园林、风景园林 </p>
            <p><strong>13</strong><strong>、</strong><strong>物理、地理、生物交叉专业</strong> </p>
            <p>
              水土保持与荒漠化防治 </p>
            <p><strong>14</strong><strong>、</strong><strong>语文、历史、哲学交叉专业</strong> </p>
            <p>
              国学 </p>

          </div>
          <p> <strong>注意：</strong>报告所显示的专业排序不一定与学科兴趣一致。专业报告的排序算法中，内在性格与人格因素权重更高，因为和学科兴趣相比，内在个性对人一生的影响更加长久和稳固。影响排序算法的因素包括人格、兴趣和职业锚点等多种因素。尤其针对理科生而言，培养学科兴趣是学好相关科目最好的老师和促进剂，然而培养出来的兴趣和内在人格特质所决定的适合职业领域以及相关专业有时候是迥异的。如果学科兴趣关联的专业和人格所得出的适合专业不一致，则看兴趣是否是自己内在真正的兴趣(而非为应试而培养出的兴趣)，如果是，当然选择自己真正喜欢和感兴趣的专业，而非报告的推荐。毕竟最了解你的人是你自己，而非任何一种理论模型。
          </p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "",
  
  
  
};
</script>


<style scoped lang='less'>
.content {
  max-width: 800px;
  margin: 0 auto;
}
.main {
  .home_page {
    background-image: linear-gradient(#8950d5, #bb85e7);
    color: white;
    overflow: hidden;
    margin-bottom: 30px;
  }
  .body {
    padding: 20px;
  }
  .border {
    padding: 20px;
    padding-bottom: 40px;
    border: 1px solid #c4a7e9;
    position: relative;
    margin-top: 57px;
    .title {
      position: absolute;
      top: -23px;
      left: 276px;
      height: 41px;
      width: 200px;
      background: #c4a7e9;
      text-align: center;
      line-height: 40px;
      color: white;
    }
  }

  .tables {
    border: 1px solid #c4a7e9;
  }

  .line div {
    padding: 6px;
    font-weight: bold;
    background-color: #ffffff;
  }
  .l {
    float: left;
  }
  .r {
    float: right;
    margin-bottom: 0px;
  }
}
.n_title {
  display: inline-block;
  text-indent: 2rem;
  position: relative;
  left: -21px;
  background: #c4a7e9;
  color: white;
  margin-top: 90px;
  margin-bottom: 20px;
  width: 300px;
}
.right {
  display: inline-block;
  width: 400px;
  span {
    width: 20%;
    text-align: center;
    display: inline-block;
  }
}
.txt {
  line-height: 30px;
}
#chart {
  width: 500px;
  height: 500px;
  margin: 100px auto 0;
}
.tables1 {
  margin-top: 10px;
  border-collapse: collapse;
  td {
    border: 1px solid rgb(173, 169, 169);
  }
}
.print {
  position: fixed;
  bottom: 100px;
  right: 200px;
}
</style>
